module.exports = __webpack_public_path__ + "img/full_logo_gw.f519ad40.svg";